export const STORAGE_TO_REGISTER_WITH_MFT = '100000000000000000000000';
export const REF_FINANCE_ID = 'v2.ref-finance.near';
export const JUMBO_ID = 'v1.jumbo_exchange.near';
export const SPIN_ID = 'spot.spin-fi.near';
export const TONIC_ID = 'v1.orderbook.near';
export const WRAPPED_NEAR_ID = 'wrap.near';
export const MEMO = 'perk';
// TODO: change
export const REFERRAL_ID = 'arbitoor.near';

export const DEFAULT_GAS = '150000000000000';

export * from './jsbi';
